import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Hotel } from 'shared/api/tours/search'
import { getCleanHTML } from 'shared/lib/getCleanHTML.ts'

import s from './styles.module.scss'

interface Props {
  data: Hotel['hotel_descr']
}

export const AboutHotel: FC<Props> = ({ data }) => {
  const { t } = useTranslation()
  return (
    <div className={s.aboutHotel}>
      <p className={clsx('bold-22', s.title)}>{t('tours_block.about_hotel')}</p>

      <div className={s.textBlock}>
        <p className={clsx('bold-14', s.subtitle)}>
          {t('tours_block.description')}
        </p>
        <div
          className={clsx('medium-14', s.description)}
          dangerouslySetInnerHTML={{
            __html: getCleanHTML(data || '', { forbiddenTags: ['img', 'svg'] }),
          }}
        />
      </div>
    </div>
  )
}
